<script>
  import {onMount} from 'svelte';

  export let haveIcon;
  export let value = '';
  export let maxLength = '';
  export let placeholder = '';
  export let autocomplete = 'on';
  export let disabled = false;
  export let isError = false;
  export let autofocus = false;
  export let placeholderColor = false;
  export let modalUI = false;
  export let hasCodeIcon = false;
  export {className as class};

  let className = '';
  let input = null;

  onMount(() => {
    autofocus && setTimeout(() => input && input.focus(), 0);
  });

  function handleInputChangeValue(e) {
    value = e.target.value.trim();
  }
</script>

<style>
  .light-gray {
    color: var(--T4);
  }
  .item {
    border: 1px solid #e9ecef;
    border-radius: 8px;
    height: 48px;
  }
  .item.error {
    border: 1px solid var(--red-main);
  }
  .item:focus-within,
  .item:hover {
    border: 1px solid var(--blue-main-hover);
  }
  .ipt {
    border: none;
    height: 88%;
    outline: none;
  }
  .ipt::-webkit-input-placeholder {
    font-family: var(--common-family);
    color: var(--T3);
  }
  .placeholder-color::-webkit-input-placeholder {
    color: #c5c8ce;
  }
  input[disabled] {
    background: transparent;
  }
  .disabled {
    background: #efefef;
  }
  .disabled input.autofill:-webkit-autofill {
    box-shadow: 0 0 0 1000px #efefef inset;
  }
  .modal-ui input::placeholder {
    color: #9fa3ab;
  }
</style>

<div class="item df aic ph16 {className}" class:error={isError} class:disabled class:modal-ui={modalUI}>
  {#if !haveIcon}
    <i class="ml4 iconfont f18 light-gray">&#xe643;</i>
  {/if}
  {#if hasCodeIcon}
    <i class="ml4 iconfont f18 light-gray">&#xe6c9;</i>
  {/if}
  <input
    class="autofill ml4 ipt f1"
    class:placeholder-color={placeholderColor}
    type="text"
    name="username"
    {autocomplete}
    {placeholder}
    {disabled}
    {maxLength}
    bind:this={input}
    {value}
    on:blur
    on:focus
    on:keypress
    on:input={handleInputChangeValue}
  />
</div>
